export default __webpack_public_path__ + "static/media/ventureverse-card-image-widget.cef90435.png";